module.exports = __webpack_public_path__ + "static/media/PATS_4-768w.5cb22568.webp";